export const GoogleIds = {
  HoustonDevGoogleId: 'G-K0G5B95Z0H',
  HoustonQAGoogleId: 'G-QEY7TBVK3J',
  HoustonUATGoogleId: 'G-6Z60W4KT6G',
  HoustonProdGoogleId: 'G-SYS2WPKG3V',
  PuursDevGoogleId: 'G-LNVKYHHEMC',
  PuursQAGoogleId: 'G-PCCBNE6XXD',
  PuursUATGoogleId: 'G-QZMDC945R3',
  PuursProdGoogleId: 'G-5QQG9ZJKSX',
} as const;
